import * as React from 'react';
import { useVariableValue } from '../../types/dvcVariableTypes';
import HybridLink from '../common/HybridLink/HybridLink';
import { UserPanel } from './UserPanel';
import cn from '~modules/cn';
import LogoNetlifyCreate from '../../assets/logo-netlify-create.svg';
import LogoNetlifyCreateDark from '../../assets/logo-netlify-create-dark.svg';
import './header.scss';

interface HeaderProps {
    user?: $TSFixMe;
    transparent?: boolean;
    fixed?: boolean;
    disableSignin?: boolean;
    wide?: boolean;
    headerLinks?: boolean;
    logoLink?: boolean;
}

const Header = ({ user, transparent, fixed, disableSignin, logoLink = true, headerLinks = true, wide }: HeaderProps) => {
    const classes = cn(`header`, {
        'header-transparent': transparent,
        'header-fixed': fixed
    });
    const exampleFeatureValue = useVariableValue('example-feature', false);
    const containerClasses = cn(`header-container`, { 'header-container-contained': !wide });

    return (
        <div className={classes}>
            <div className={containerClasses}>
                {logoLink ? (
                    <HybridLink className="logo-wrapper" to={user ? '/dashboard' : 'https://www.stackbit.com'}>
                        <LogoNetlifyCreate className="logo" />
                    </HybridLink>
                ) : (
                    <div className="logo-wrapper logo-wrapper-non-link">
                        <LogoNetlifyCreateDark className="logo" />
                    </div>
                )}
                {headerLinks && (
                    <div className="header-links">
                        <HybridLink to="/">
                            Dashboard
                            {exampleFeatureValue ? ' Experiment ON' : null}
                        </HybridLink>
                    </div>
                )}
                <UserPanel key="user" user={user} disableSignin={disableSignin} />
            </div>
        </div>
    );
};

export default Header;
